module.exports = __webpack_public_path__ + "static/media/intropic.92c3e239.jpeg";